<template>
  <div class="ProjectChangeReportComponent DataTables">
    <p>{{lang.infotext_1}}:</p>

    <div v-show="isData" :id="id"></div>

    <LoaderComponent  v-if="!isData"></LoaderComponent>

    </div>
</template>
<script>

import LoaderComponent from "@/components/shared/LoaderComponent";
import $ from 'jquery';
import dt from 'datatables.net-bs4';
import * as Tools from './../../Tools/Tools'

export default {
  name: 'ProjectChangeReportComponent',
  props:{
    lang: Object,
    parent: String
  },
  components: {
    LoaderComponent

  },
  data () {
      return {
        name: 'ProjectChangeReportComponent',
        mainTable: "",
        id: "ProjectChangeReportComponent" + this._uid,
        columns: [],
        colsAssign: [],
        elements: [],
        isData: false

      }
  },
  computed: {
    lastRevisionHistory() {
      if (this.$store.getters.revisionHistory == null) {
        return
      }
      let tab = this.$store.getters.revisionHistory;
      let obj = tab[0];
      for (let i = 0, lei = tab.length; i < lei; i++) {

        if (tab[i].revision > obj.revision) {
          obj = tab[i];
        }
      }

      return obj;
    },
    revisionId() {
      
      if (this.$route.path == "/ProjectManager/ProjectDetails") {
        if (this.$store.getters.selectedRevisionRow.length == 0) {
          return null;
        }
        return this.$store.getters.selectedRevisionRow[0].revisionId;
      }
      if (this.$route.query.revisionId != undefined) {
        return this.$route.query.revisionId;
      }

      if (this.$store.getters.selectedRevisionRow.length == 0) {
        return null;
      }

      return this.$store.getters.selectedRevisionRow[0].revisionId;
      

    },
    projectId() {
      if (this.lastRevisionHistory == undefined) {
        return
      }
      return this.lastRevisionHistory.projectId;
      // if (this.$store.getters.selectedRows[0] != undefined){
      //   return this.$store.getters.selectedRows[0].col___revisionId.projectId;
      // }
      // return ""
    },
    
    reloadedAfterAction(){
        return this.$store.getters.reloadedAfterAction;
    }

  },
  created () {

    this.createTable();


  },
  watch: {
    revisionId: {
      handler: function(newVal, oldVal){
        
        this.createTable();
      },
      deep: true
    
      
    },
    
    reloadedAfterAction: function(newValue, oldValue){

      if (newValue.name == this.name){
        if (newValue.status == true){
            
            this.createTable();
            
            newValue.status = false;
            newValue.name = "";
            this.$store.dispatch("reloadAfterAction", newValue);
        }
      }
    }
  },
  updated() {

  },
  mounted: function () {

  },
  methods: {
    createTable(){
      let vue = this;

      let obj = {
      
          revisionId: this.revisionId
      
        
      }
      console.log(obj)
      
      this.$store.dispatch(this.$store.getters.sectionPrefix + "_projectChangeReport", obj)
      .then((result) => {
        console.log(result)
        if (result.status == "OK"){

          this.elements = [];
          for (let i = 0, lei = result.data.length; i < lei; i++){

            let name = result.data[i].libraryNumber;
            if (result.data[i].type == "part"){
              name = result.data[i].partNumber;
            }

            const obj = {
              projectRevisionId: result.data[i].projectRevisionId,
              name: name,
              type: result.data[i].type,
              status: "changed",
              creationDate: Tools.longDateToShort(result.data[i].creationDate),
              partId: result.data[i].partId,
              partRevisionId: result.data[i].partRevisionId,
              libraryId: result.data[i].libraryId,
              libraryRevisionId: result.data[i].libraryRevisionId,
              libraryType: result.data[i].libraryType
            }

            this.elements.push(obj)
          }
          
          vue.isData = true;  
          


          vue.buildColumns();


        }else{
            vue.isData = false;  
        }


      })
    },
    buildColumns(){

      this.columns = [
        {
          name: "Id",
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Name,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_Type,
          alignInColumn: "left",
          type: "taxt"
        },
        {
          name: this.lang.table_header_Status,
          alignInColumn: "left",
          type: "text"
        },
        {
          name: this.lang.table_header_When,
          alignInColumn: "left",
          type: "text"
        },
        
      ]

      this.colsAssign =  [
        { "data": "projectRevisionId" },
        { "data": "name" },
        { "data": "type" },
        { "data": "status"},
        { "data": "creationDate"},
        // { "data": "libraryId" },
        // { "data": "libraryRevisionId" },
        // { "data": "partRevisionId" },
        // { "data": "partId" },
               
      ]

      this.buildTable();
    },
    buildTable(){
          
      var tableplace = document.getElementById(this.id);
      if (tableplace == null){
        return;
      }

      while (tableplace.firstChild) {
          tableplace.removeChild(tableplace.firstChild);
      }

      var table = document.createElement("table");
      table.setAttribute("id", "t_" + this.id);
      table.setAttribute("style", "width:100%");
      table.setAttribute("class", "table table-striped table-bordered");
      tableplace.appendChild(table)

      var tr = document.createElement("tr");
      tr.setAttribute("class", "cellHeader");
      var thead = document.createElement("thead");
      thead.appendChild(tr);
      table.appendChild(thead);

      var _vue = this;


      let columnDefs = [];
      var len = this.columns.length;
      for (var i = 0; i < len; i++){

        var el = {};

        var classname = '_dt-body-'+ this.columns[i].alignInColumn;

        el = {
          targets: i,
          className: classname,

          render: function ( data, type, row, meta ) {
            if (data == null) {
              data = "";
            }

            data = $.fn.dataTable.render.text().display(data);
            if (data.display != undefined) {
              data.display = $.fn.dataTable.render.text().display(data.display);
            }

            if (meta.col == 3){
              if (data == null){
                return "";
              }
              
              return "<b-badge class='badge badge-warning'>"+data+"</b-badge>";
            }
            

            return data;
          }


        }

        columnDefs.push(el);


        var th = document.createElement("th");
        tr.appendChild(th);
        //var p = document.createElement("p");
        //th.appendChild(p);
        var br = document.createElement("br");
        th.appendChild(br);
        var tx = document.createTextNode(this.columns[i].name)
        th.appendChild(tx);

      }


      var option = {};
      option.paging = true;
      option.info = true;
      option.dom = '<fr<t>ip>';
      option.data= this.elements;
      option.myColumnFormats = this.columns;
      option.select = true;
      option.order = [[3, "asc"]];
      option.lengthMenu = [[20]];
      option.columns = this.colsAssign;

      option.columnDefs = columnDefs;
      option.initComplete = function () {


        console.log("complete")

      }




      if ($.fn.dataTable.isDataTable("#t_"+this.id)) {
          this.mainTable.destroy();
          console.log("DESTROY TABLE")
      }

      var _vue = this;

      this.mainTable = $('#t_'+this.id).DataTable(option);

      this.mainTable.columns.adjust().draw();

      //hide first column in table
      this.mainTable.column( 0 ).visible( false );

      let _mainTable = this.mainTable;

      this.mainTable
        .on( 'select', function ( e, dt, type, indexes ) {

          var rowData = _mainTable.rows( indexes ).data();
          console.log("select")
          console.log(rowData[0])

          //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_setSelectedProjectRow", rowData[0])

        })
        .on( 'deselect', function ( e, dt, type, indexes ) {
          console.log("deselect")
          //_vue.$store.dispatch(_vue.$store.getters.sectionPrefix + "_deleteSelectedProjectRow");
        })

        $("#t_"+this.id +" tbody").on('dblclick', 'tr', function () {

               
          let rowData = _mainTable.rows( this._DT_RowIndex ).data();

          _vue.goTo(rowData[0]);
                
        });

      //search input change view
      var searchplace = document.getElementById("t_"+this.id + "_filter").firstChild

      while (searchplace.firstChild) {

        if (searchplace.firstChild.textContent == "Search:"){
            searchplace.removeChild(searchplace.firstChild);
            break;
        }

      }
      searchplace.firstChild.setAttribute("placeholder", this.lang.placeholder_Search);
      searchplace.firstChild.setAttribute("class", "form-control form-control-sm")


    },
    goTo(goalObj){
      
      let from = "/ProjectManager/ProjectDetails";

      let to = "/PartManager/PartDetails";
      let elementRevisionId = goalObj.partRevisionId;
      let id = goalObj.partId;
      let obj = {
        col___revisionId: {
          revisionId: goalObj.partRevisionId,
          partId: goalObj.partId
        },
        col___revision: {
          revisionId: ""
          
        },
        col___status: {
          assembly: ""
          
        }
      }

      
      if (goalObj.type == "library"){
        to = "/LibraryManager/LibraryDetails";
        elementRevisionId = goalObj.libraryRevisionId;
        id = goalObj.libraryId;
        obj = {
          col___revisionId: {
            revisionId: goalObj.libraryRevisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.libraryRevisionId
            }
          },
          col___revision: {
            revisionId: goalObj.libraryRevisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: ""
            }
          },
          col___status: {
            revisionId: goalObj.libraryRevisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.status
            }
            
          },
          col___name: {
            revisionId: goalObj.libraryRevisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.name
            }
            
          },
          col___image: {
            revisionId: goalObj.libraryRevisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: ""
            }
          },
          col___libraryType: {
            revisionId: goalObj.libraryRevisionId,
            libraryId: goalObj.libraryId,
            value: {
              display: goalObj.libraryType
            }
          }
        }
      }

      const goToObj = {
        to: {
          path: to,
          revisionId: elementRevisionId,
          id: id
        },
        back: {
          path: from,
          revisionId: this.revisionId,
          id: this.projectId
        }
      }
      this.$store.dispatch("goTo", goToObj);
      


      this.$store.dispatch("deleteAllSelectedRows");
      this.$store.dispatch("setSelectedRows", obj);
      
      this.$store.dispatch("setOuterData", true);

      this.$store.dispatch("editPropertiesForm", false);



      
      const query = {
        from: this.$route.path,
        to: to,
        end: true,
        revisionId: elementRevisionId,
        id: id
      }

      this.$router.push({ path: to, query: query });
    }

  }
}
</script>


<style lang="scss">
  .ProjectChangeReportComponent{
    width: 100%;
    .dataTable{
        width: 100%;
    }
    table{
      font-size: 0.75rem;
      padding: 0px !important;
      
    }
    table th {
      padding: 2px !important;

    }
    table th select{
      width: 100% !important;

    }
    table td {
      padding: 0rem !important;

      padding-left: 0.2rem !important;
      padding-right: 0.2rem !important;

    }
    table.dataTable thead th {
        position: relative;
        background-image: none !important;
    }
    table.dataTable thead th p{
      margin-right: 20px;
    }

    .dataTables_processing {
      position: absolute;
      top: 20px;
      left: 50%;
      width: 100%;
      height: 20px;
      margin-left: -50%;
      margin-top: 50px;
      padding-top: 5px;
      text-align: center;
      font-size: 1em;

    }

    .dataTables_filter{
      font-size: 10px;
      float: left;
      width: 210px;
    }
    .searcher{
      float: left;
    }
    .dt-buttons{

      font-size: 0.7rem;
      margin-left: 210px;

    }
    .dataTables_filter .form-control-sm, .input-group-sm > .form-control{
      padding: 0.1rem 0.1rem;
      font-size: 0.7rem;
      line-height: 1;
      width: 200px;
    }
    .btn{
      padding-top: 1px;
      padding-bottom: 1px;
      padding-left: 3px;
      padding-right: 3px;

      font-size: 0.7rem;

    }
    .btn-group{
      display: block;
      padding-top: 2px;
    }
    ._dt-body-left{
      text-align: left;
    }
    ._dt-body-right{
      text-align: right;
    }
    ._dt-body-center{
      text-align: center;
    }
    .image{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
    }
    .imageSVG{
      max-width: 40px;
      border: solid 3px #666;
      border-radius: 2px;
      margin-top: 3px;
      margin-bottom: 3px;
      padding: 5px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/shared/ProjectChangeReportComponent.vue